/**
 * The Daily sales report's date limits. The page offers them and the endpoint
 * enforces them, so both read them from here rather than each holding a copy.
 */

/** Days shown when no dates are chosen, ending today. */
export const DAILY_SALES_DEFAULT_DAYS = 21;

/** The longest range, counting both ends: enough for any calendar quarter. */
export const DAILY_SALES_MAX_DAYS = 92;

/** No sales are recorded before this date, so nothing earlier can be asked for. */
export const DAILY_SALES_EARLIEST_DATE = '2020-01-01';
